module.exports = __webpack_public_path__ + "static/avatar-2a39ba25d926e1b2576a3507487dfa12.jpg";